import { Money } from '@dreryk/money-common-api';

import { TextView } from '@dreryk/react-components';
import { getCustomFormattingContext, priceFormatter } from '@dreryk/react-common';

import { translationKeys } from '../translations';

type AdvancePaymentRemainingAmountTextViewProps = Readonly<{ remainingAmount: Money }>;

export const AdvancePaymentRemainingAmountTextView = (
   props: AdvancePaymentRemainingAmountTextViewProps
): JSX.Element => {
   return (
      <TextView testId={'advancePaymentRemainingAmount'} label={translationKeys.advancePaymentRemainingAmount}>
         {priceFormatter(
            props.remainingAmount.asNumber(),
            getCustomFormattingContext({
               options: {
                  currency: 'PLN',
                  stripDecimalZeroes: true,
               },
            })
         )}
      </TextView>
   );
};
